<template>
  <div v-if="isShow" class="seo-page-content">
    <UiText
      v-if="title"
      tag="h1"
      font="promo-heading-1"
      color="typography-title01"
      :text="title"
      class="seo-page-content__title"
    />

    <div v-if="text" class="seo-page-content__desc custom-scrollbar gray">
      <UiTextTags class="seo-page-content__text" :html="text" />
    </div>
  </div>
</template>

<script>
import UiTextTags from '@/components/ui/UiTextTags'
import { mapGetters } from 'vuex'

export default {
  name: 'SeoPageContent',
  components: {
    UiTextTags,
  },
  props: {
    h1: { type: String },
    description: { type: String },
  },
  computed: {
    ...mapGetters('seo', ['get_seoPage']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('base', ['isServerToken']),
    isShow() {
      return !this.isLoggedIn && !this.isServerToken && (this.title || this.text)
    },
    title() {
      return this.h1 || this.get_seoPage.h1 || this.get_seoPage.title
    },
    text() {
      return this.description || this.get_seoPage.footer[0]
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
